import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';

function PaymentMethods(props) {
  const stripe = useStripe();
  const elements = useElements();
  const { clientSecret } = props;

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      console.error(submitError);
      return;
    }

    const { error } = await stripe.confirmSetup({
      elements,
      clientSecret,
      confirmParams: {
        return_url: 'http://localhost:3000/',
      },
    });

    if (error) {
      console.error(error);
    }
  };

  return (
    <div className="stripe-paiment-form">
      <PaymentElement />
      <button
        disabled={!stripe}
        onClick={handleSubmit}
        className="stripe-paiment-submit"
      >
        Confirmer
      </button>
    </div>
  );
}

export default PaymentMethods;
